const {Component} = require("react");
const PropTypes = require("prop-types");
const LocationField = require("app/components/fields/Location");
const router = require("app/services/router");
const debounce = require("app/util/debounce");
const axios = require("axios");

const env = require('app/services/env')


class ZipCity extends Component {

  static get propTypes() {
    return {
      id: PropTypes.string,
      name: PropTypes.string,
      zip: PropTypes.string,
      city: PropTypes.string,
      region: PropTypes.string,
      zipPlaceholder: PropTypes.string,
      cityPlaceholder: PropTypes.string,
      regionPlaceholder: PropTypes.string,
      onChange: PropTypes.func
    };
  }

	static get defaultProps() {
		return {
			id: "zipCityInput",
			zipPlaceholder: translate("Postnr"),
			cityPlaceholder: translate("By"),
            regionPlaceholder: translate("Delstat"),
		};
	}

  constructor(props) {
    super(props);
    this.state = {
      zip: props.zip,
      city: props.city,
      region: props.region,
      first_change: true
    };
  }

  componentDidUpdate(prevProps) {
    let state = {};

    if (prevProps != this.props && this.state.first_change) {

      state.first_change = false;

      if (this.props.zip) {
        state.zip = this.props.zip;
      }

      if (this.props.city) {
        state.city = this.props.city;
      }

      if (this.props.region) {
        state.region = this.props.region
      }

      if (Object.keys(state).length > 0) {
        this.setState(state);
      }
    }
  }

  getRegionOptionValue() {
    return env.get('options.show_region_field', false)
  }

  setValue(zip, city = null, region = null) {
    // Trigger change
    if (typeof this.props.onChange === "function") {
      this.props.onChange(zip, city, region);
    }

    this.setState({zip, city, region});
  }

  get name() {
    return this.props.name;
  }

  get value() {
    return this.zipElement.value;
  }

  _handleInputEvent = debounce(1000, () => {
    const value = this.zipElement.value;

    axios
      .get(router.route("api.zipCode.get", {zipcode: value}))
      .then(response => {
        this.setValue(value, response.data.city, response.data.region);
      })
      .catch(() => {
        this.setValue(value, null, null);
      });
  });

  _onInput = () => {
    const defaultValue = this.zipElement.value;
    this.zipElement.value = defaultValue.replace(/[^0-9]/g, "");

    if (this.zipElement.value !== defaultValue) {
      this._handleInputEvent();
    }
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.zip != this.props.zip) {
      this.setState({
        zip: this.props.zip,
        city: this.props.city,
        region: this.props.region
      })
    }
  }

  renderRegion() {
    if (this.getRegionOptionValue()) {
      if (this.state.region && (this.state.region.length > 0)) {
        return (
          <div className="city" title={this.state.region}>{this.state.region}</div>
        );
      }
      return (
        <div className="city placeholder">{this.props.regionPlaceholder}</div>
      )
    }
  }


  renderZip() {
    return (
      <LocationField id={this.props.id} name={this.props.name} autoComplete={this.props.autoComplete}
                     ref={el => this.zipElement = el}
                     onChange={this._handleInputEvent}
                     onInput={this._onInput}
                     defaultValue={this.state.zip}
                     placeholder={this.props.zipPlaceholder}
                     pattern="\d*"
                     />
    );
  }

  renderCity() {
    if (this.state.city && (this.state.city.length > 0)) {
      return (
        <div className="city" title={this.state.city}>{this.state.city}</div>
      );
    }

    return (
      <div className="city placeholder">{this.props.cityPlaceholder}</div>
    );
  }

  render() {
    return (
      <>
        <div className="zip-city-field">
          {this.renderZip()}
          {this.renderCity()}
        </div>
        <div className="zip-region-field">
          {this.renderRegion()}
        </div>
      </>
    );
  }

}

module.exports = ZipCity;
